import React from "react";
import ACTimage from "../../../assets/ACT.png";
import {
  Heart,
  Bullseye,
  Layers,
  ArrowRightCircle,
  PersonCheck,
  Lightbulb,
  Check2
} from "react-bootstrap-icons";

function TherapyIcon({ name }) {
  if (name === "acceptance") return <Heart className="therapy-icon" />;
  if (name === "values") return <Bullseye className="therapy-icon" />;
  if (name === "defusion") return <Layers className="therapy-icon" />;
  if (name === "action") return <ArrowRightCircle className="therapy-icon" />;
  if (name === "self") return <PersonCheck className="therapy-icon" />;
  if (name === "idea") return <Lightbulb className="therapy-icon" />;
  return null;
}

function CheckIcon() {
  return <Check2 className="therapy-check" />;
}

export default function ACTModal({ setShow }) {
  return (
    <>
      <div
        className="therapy-modal-backdrop"
        onClick={() => setShow(false)}
      />

      <div
        className="modal fade show d-block therapy-modal-wrap"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg therapy-modal-dialog">
          <div className="modal-content therapy-modal-content">
            <div className="therapy-modal-hero">
              <div className="therapy-modal-hero-inner text-center">
                <img
                  src={ACTimage}
                  className="img-fluid mx-auto d-block mb-3"
                  alt="ACT"
                />

                <h5 className="therapy-modal-title">
                  What is ACT
                </h5>

                <div className="therapy-modal-subtitle">
                  Acceptance and Commitment Therapy explained
                </div>
              </div>

              <button
                type="button"
                className="btn-close therapy-modal-close"
                onClick={() => setShow(false)}
                aria-label="Close"
              />
            </div>

            <div className="modal-body therapy-modal-body">
              <div className="therapy-modal-card">
                <div className="therapy-modal-item">
                  <div className="therapy-modal-item-icon">
                    <TherapyIcon name="acceptance" />
                  </div>
                  <div className="therapy-modal-item-content">
                    <div className="therapy-modal-item-title">
                      Acceptance and Commitment Therapy
                    </div>
                    <div className="therapy-modal-item-text">
                      ACT helps you make room for difficult thoughts and feelings
                      while taking steps towards what matters to you. The aim is
                      psychological flexibility, so you can respond with choice
                      rather than getting stuck in a struggle.
                    </div>
                  </div>
                </div>

                <div className="therapy-modal-item">
                  <div className="therapy-modal-item-icon">
                    <TherapyIcon name="values" />
                  </div>
                  <div className="therapy-modal-item-content">
                    <div className="therapy-modal-item-title">
                      Values led living
                    </div>
                    <div className="therapy-modal-item-text">
                      ACT puts a lot of focus on clarifying what matters most to
                      you. Values act like a compass, helping you choose actions
                      that move you towards the life you want.
                    </div>
                  </div>
                </div>

                <div className="therapy-modal-item">
                  <div className="therapy-modal-item-icon">
                    <TherapyIcon name="defusion" />
                  </div>
                  <div className="therapy-modal-item-content">
                    <div className="therapy-modal-item-title">
                      Defusion
                    </div>
                    <div className="therapy-modal-item-text">
                      Instead of treating thoughts like facts, ACT teaches ways
                      to step back and notice them. This can reduce the pull of
                      unhelpful thoughts so they have less control over what you
                      do next.
                    </div>
                  </div>
                </div>

                <div className="therapy-modal-item">
                  <div className="therapy-modal-item-icon">
                    <TherapyIcon name="self" />
                  </div>
                  <div className="therapy-modal-item-content">
                    <div className="therapy-modal-item-title">
                      Perspective taking
                    </div>
                    <div className="therapy-modal-item-text">
                      ACT helps you notice that you are more than your thoughts
                      or feelings. Building this observing perspective can make
                      it easier to handle difficult experiences without being
                      overwhelmed by them.
                    </div>
                  </div>
                </div>

                <div className="therapy-modal-callout">
                  <div className="therapy-modal-callout-icon">
                    <TherapyIcon name="idea" />
                  </div>
                  <div className="therapy-modal-callout-text">
                    <span className="therapy-modal-callout-strong">
                      ACT is not about getting rid of feelings,
                    </span>{" "}
                    it is about changing your relationship with them so you can
                    keep moving towards what matters.
                  </div>
                </div>

                <div className="therapy-modal-split">
                  <div className="therapy-modal-split-left">
                    <div className="therapy-modal-item-title mb-2">
                      ACT helps clients to
                    </div>

                    <div className="therapy-modal-checklist">
                      <div className="therapy-modal-check">
                        <CheckIcon />
                        <div>
                          Notice difficult thoughts and feelings without
                          fighting them
                        </div>
                      </div>

                      <div className="therapy-modal-check">
                        <CheckIcon />
                        <div>
                          Create space from unhelpful thoughts using defusion
                          skills
                        </div>
                      </div>

                      <div className="therapy-modal-check">
                        <CheckIcon />
                        <div>
                          Get clear on values and use them to guide decisions
                        </div>
                      </div>

                      <div className="therapy-modal-check">
                        <CheckIcon />
                        <div>
                          Take committed action towards goals even when it feels
                          hard
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="therapy-modal-split-right">
                    <div className="therapy-modal-note">
                      ACT is usually skills based and practical. Sessions often
                      include simple exercises you can use in daily life to
                      build flexibility, strengthen values led choices, and
                      reduce time spent stuck in avoidance or overthinking.
                    </div>
                  </div>
                </div>

                <div className="therapy-modal-item">
                  <div className="therapy-modal-item-icon">
                    <TherapyIcon name="action" />
                  </div>
                  <div className="therapy-modal-item-content">
                    <div className="therapy-modal-item-title">
                      Committed action
                    </div>
                    <div className="therapy-modal-item-text">
                      Progress in ACT comes from small, realistic steps. The aim
                      is not perfection, it is building momentum towards the
                      kind of life you want to live.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer therapy-modal-footer">
              <button
                className="btn btn-brand-white fw-semibold therapy-modal-footer-btn"
                onClick={() => setShow(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
